import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * ComparisonPage — redirects to SimulationPage.
 *
 * The new SimulationPage already shows siloed vs orchestrated comparison inline,
 * so this page is no longer needed as a separate view.
 */
export default function ComparisonPage() {
    const { projectId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        navigate(`/ems/${projectId}`, { replace: true });
    }, [projectId, navigate]);

    return null;
}
